import React from 'react';

// Components

import TagModal from './modals/TagModal';
import TicketTypeModal from './modals/TicketTypeModal';

// Constants

import { ticketMgmtModalTypes } from '@constants/ticketMgmt/modals/ticketMgmtModalTypes';

const ModalContainer = props => {
    const {
        actions,
        data,
        modal,
        modal: {
            modalType
        },
        ...restProps
    } = props;

    const extendedProps = {
        ...restProps,
        actions,
        data,
        modal
    };

    const getModal = () => {
        switch(modalType) {
            case ticketMgmtModalTypes.TICKET_TYPE_MODAL:
                return <TicketTypeModal { ...extendedProps }/>;
            case ticketMgmtModalTypes.TAG_MODAL:
                return <TagModal { ...extendedProps } />;
        }
    };

    return getModal();
};

export default ModalContainer;
